<template>
  <div>
    <div
      class="container"
      v-for="item_group in item_list"
      :key="item_group.code"
    >
      <div class="plans tab_accessory">
<!--
        <h2 class="ttl">
          {{ item_group.name }}
        </h2>
-->
        <div
          class="in__container"
        >
          <div v-if="item_group.list[0].code==='-'">
            <label class="plan basic-plan">
              <input type="radio" checked/>
              <div class="plan__content">
              <p class="plan__noselect">{{ item_group.list[0].name }}</p>
              </div>
            </label>
          </div>
          <div v-else>
          <label
            class="plan"
            v-for="(item, index) in item_group.list"
            :key="item.code"
            @click="
              $emit(
                'click-Item',
                'accessories',
                item_group.code,
                item.code,
                index
              )
            "
          >
            <input
              type="radio"
              :name="item_group.code"
              :value="item.code"
              v-model="check_value[item_group.code]"
            />
            <div class="plan__content">
              <div class="plan__thumb">
                <img
                  loading="lazy"
                  :src="item.image"
                  alt=""
                  width="160"
                  class="accessory-img"
                />
              </div>
              <div class="plan__details">
                <div class="inner_box">
                  <p class="plan__name br_application">{{ item.name }}</p>
                  <p class="plan__price">
                    <span>¥ {{ item.price }}</span>
                  </p>
                </div>
                <p class="plan__details_text br_application">
                  {{ item.detail }}
                </p>
              </div>
            </div>
          </label>
          <label
            class="plan basic-plan"
            @click="$emit('click-Item', 'accessories', item_group.code, '', -1)"
          >
            <input
              type="radio"
              :name="item_group.code"
              value=""
              v-model="check_value[item_group.code]"
            />
            <div class="plan__content">
              <p class="plan__noselect">選択しない</p>
            </div>
          </label>
          </div>
        </div>
      </div>
    </div>
    
      <label class="plan basic-plan" v-if="item_list.length === 0">
        <input type="radio" checked/>
        <div class="plan__content">
        <p class="plan__noselect">選択なし</p>
        </div>
      </label>
      
    
  </div>
</template>

<script>
export default {
  props: ["item_list", "check_value"],
  setup() {},
};
</script>
<style scoped></style>